import { ArrowRight } from "lucide-react";
import { cn } from "@/lib/utils";
import { openWebinar } from "@/data/content";

export const CTAButton = ({
  children = "Kostenlos zum Webinar anmelden",
  className,
  size = "lg",
  testId,
}) => {
  const sizes = {
    lg: "px-8 py-4 text-base sm:text-lg",
    md: "px-6 py-3 text-sm sm:text-base",
  };
  return (
    <button
      type="button"
      onClick={openWebinar}
      data-testid={testId}
      className={cn(
        "group relative inline-flex items-center justify-center gap-3 rounded-full",
        "bg-brand-green text-brand-bg font-heading font-bold uppercase tracking-[0.03em]",
        "glow-green transition-transform duration-300 will-change-transform",
        "hover:scale-[1.03] active:scale-[0.99]",
        sizes[size],
        className,
      )}
    >
      <span>{children}</span>
      <ArrowRight
        className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-1"
        strokeWidth={2.5}
      />
    </button>
  );
};
